import { loadFiles } from '../common/api';

const files = {
    name: 'files',
    state: {
        loaded: false, 
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.fid
            }
        },
        cdcInsert: ( state, payload ) => {
            // might receive assoc insert first, so can't assume first time seeing anying for this id
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.fid]: {
                        ...state.byId[payload.fid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.fid]: {
                        ...state.byId[payload.fid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.fid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedFiles: ( state, payload ) => {
            return {
                ...state,
                loaded: true,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadFiles( { aid, uid } ) {
            const list = await loadFiles( aid, uid );
            let byId = {};
            list.forEach( c => byId[c.fid] = c );
            dispatch.files.loadedFiles( byId );
        },
        insert( { fid, cdc } ) {
            dispatch.files.cdcInsert( { fid, cdc } );
        },
        modify( { fid, cdc } ) {
            dispatch.files.cdcModify( { fid, cdc } );
        },
        remove( { fid } ) {
            dispatch.files.cdcRemove( { fid } );
        },
        setCurrent( { fid } ) {
            dispatch.files.setCurrentId( { fid } );
        }
    } )
}

export default files;